/*global sessionStorage */
/*global localStorage  */
/* eslint-disable no-unused-vars */
import React from "ES/lib/react";

let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../utils/FormUtils");
let dateformat = require("ES/lib/dateformat");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let esStatusImage = require("../calendar_area/esStatusImage");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let AuthedUserSession = require("../../../utils/AuthedUserSession");
let getActionListDropDownOptions = require("../../../utils/getActionListDropDownOptions");
import SearchAContactService from "./tabs/contacts/ContactGrabber/SearchAContactService";

let buildFields = function (Displaylists, data, canOnlyCreatePersonalEvent) {
  let fields = {};
  let has_pro = _.includes(
    AuthedUserSession.getSIDsAtPackageLevel("PRO"),
    esUtils.toInt(data.speaker)
  );

  if (_.isEmpty(Displaylists)) {
    return {};
  }
  let my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, false);
  if (_.size(my_speakers) > 1) {
    fields.speaker = {
      label: "Speaker",
      type: "select",
      options: my_speakers,
    };
  }

  fields.organization = {
    label: "Presenting to",
    placeholder: "Presenting to",
    validate: FormUtils.v.required,
    type: "text",
  };

  fields.status = {
    label: "Status",
    type: "select",
    options: _.object(
      _.map(
        _.get(Displaylists, ["universal", "eventstatuses"], []),
        function (status) {
          return [status.description, status.description];
        }
      )
    ),
    dont_sort_options: true,
    read_only: AuthedUserSession.is_st_family && canOnlyCreatePersonalEvent,
    validate(s) {
      if (s == "lead" && !has_pro) {
        return "Only PRO users can have '" + s + "' events";
      }
      return true;
    },
  };

  fields.personal = {
    label: "personal / blackout",
    type: "checkbox",
    read_only: canOnlyCreatePersonalEvent,
  };

  fields.deliveryMethod = {
    type: "select",
    label: "Event Type",
    placeholder: "-- select an event type --",
    options: _.object(
      _.map(
        _.get(Displaylists, ["universal", "deliverymethods"], []),
        function (d) {
          return [d.id, d.description];
        }
      )
    ),
  };

  fields.bureauID = {
    label: AuthedUserSession.is_st_family ? "PD Rep" : "Bureau",
    type: "select",
    placeholder: "none -- direct",
    validate: FormUtils.v.optional,
    options: _.object(
      _.map(
        _.slice(_.get(Displaylists, ["universal", "bureaus"], []), 0, 1000),
        function (bureau) {
          return [bureau.bid, bureau.bname];
        }
      )
    ),
  };
  fields.bureauNotes = {
    label: AuthedUserSession.is_st_family ? "Sales Rep" : "Bureau Notes",
    type: "text",
    placeholder: AuthedUserSession.is_st_family ? "Sally Salesrep" : "...",
  };
  fields.no_date = {
    label: "no date yet (add a stagetime later)",
    type: "checkbox",
  };

  fields.contact_name = {
    label: "Name",
    placeholder: "Harry Hiredme",
    validate: FormUtils.v.optional,
    type: "text",
  };

  fields.contact_phone = {
    label: "Phone",
    placeholder: "(801) 555-1212",
    validate: FormUtils.v.optional,
    type: "phone",
  };

  fields.contact_email = {
    label: "Email",
    placeholder: "name@client.com",
    validate: FormUtils.v.optional,
    type: "email",
  };

  fields.contact_remote_id = {
    type: "hidden",
  };

  //for personal events, Balboa forces the actionlist=Standard
  if (!data.personal) {
    let actionlist_options = getActionListDropDownOptions(
      Displaylists,
      data.speaker,
      _.get(AuthedUserSession, "activeCompany.COMPANY_ID", 0)
    );
    if (actionlist_options) {
      fields.todolists = {
        label: "Action List",
        type: "select",
        placeholder: "-- select actionlist --",
        options: actionlist_options,
        dont_sort_options: false,
        validate: FormUtils.v.optional,
      };
    }
  }

  if (!data.no_date) {
    fields.starttime = {
      label: "Start",
      type: "date",
      placeholder: "Start date",
      validate: FormUtils.v.required,
      pick_time: false,
    };

    fields.stoptime = {
      label: "End",
      type: "date",
      placeholder: "End date",
      validate: FormUtils.v.required,
      pick_time: false,
      valid_range: {
        start: data.starttime,
      },
    };

    fields.add_flights = {
      label: "add temp flights day before and after (update later)",
      type: "checkbox",
      validate: FormUtils.v.optional,
    };
  }

  return fields;
};

let NewForm = dd.createClass({
  mixins: [FormMixin, RadioServiceMixin],
  has_remote_contact: false,
  getInitialValuesSourceVersion(props) {
    let url_date = props.url_date;
    return _.isDate(url_date)
      ? esUtils.format_date(url_date, "yyyy-dd-mm")
      : null;
  },

  componentWillReceiveProps(nextProps) {
    //If we grabbed a contact, we passed it into the form in the props. Test for that and update the fields if appropriate.
    let new_contact = nextProps.contact_from_grab;
    let prev_contact = this.props.contact_from_grab;
    if (new_contact && new_contact !== prev_contact) {
      const name = new_contact.name || new_contact.cname || "";
      const phone =
        new_contact.phone || new_contact.phone1 || new_contact.mobile || "";
      const email = new_contact.email || new_contact.email1 || "";
      const remote_id = _.get(new_contact, "externalid");
      const updatedData = _.cloneDeep(this.state.data);
      let hasChanges = false;
      if (!_.isEmpty(name)) {
        updatedData.contact_name = name;
        hasChanges = true;
      }
      if (!_.isEmpty(phone)) {
        updatedData.contact_phone = phone;
        hasChanges = true;
      }
      if (!_.isEmpty(email)) {
        updatedData.contact_email = email;
        hasChanges = true;
      }
      if (!_.isEmpty(remote_id)) {
        updatedData.contact_remote_id = remote_id;
        hasChanges = true;
      }

      if (hasChanges) {
        this.setState({ data: updatedData });
      }
    }
  },
  getInitialValues(props) {
    this.has_remote_contact = _.get(props, "has_remote_contact", false);
    let Displaylists = props.Displaylists;
    let lastSelectedSID = AuthedUserSession.getLastSelectedSID();
    let sid =
      lastSelectedSID ||
      _.first(_.map(Displaylists && Displaylists.perspeaker, "sid"));
    let canOnlyCreatePersonalEvent =
      !AuthedUserSession.doIHaveAccess.full.any(sid); //as for speaker users on a privatelabel who can only create blackout events

    let data = {
      speaker: sid + "",
      no_date: false,
      todolists: sid + "|0",
      status: AuthedUserSession.is_st_family
        ? canOnlyCreatePersonalEvent
          ? "confirmed"
          : "lead"
        : "held",
      country: "US",
      personal: canOnlyCreatePersonalEvent,
      add_flights: false,
      deliveryMethod: 1, //on-site
    };
    if (_.isDate(props.url_date)) {
      data.starttime = props.url_date;
      data.stoptime = props.url_date;
    }

    // set default values if we have them available from the mother event
    if (
      this.props.has_parent &&
      sessionStorage.getItem("parent_organization")
    ) {
      data.organization = sessionStorage.getItem("parent_organization");
      data.status = sessionStorage.getItem("parent_status");
      data.bureauID = sessionStorage.getItem("parent_bureauID");
      data.bureauNotes = sessionStorage.getItem("parent_bureauNotes");
      var parent_sid = JSON.parse(sessionStorage.getItem("parent_sids"))[0];
      if (parent_sid > 0) {
        data.speaker = parent_sid;
      }
      var venue = JSON.parse(sessionStorage.getItem("parent_Venue"))[0];
      _.each(venue, function (value, key) {
        data[key] = value;
      });
    }

    return data;
  },
  buildSchema(props) {
    let Displaylists = (props || this.props).Displaylists;
    let data = (this.state && this.state.data) || {};
    let canOnlyCreatePersonalEvent = !AuthedUserSession.doIHaveAccess.full.any(
      data.speaker
    ); //as for speaker users on a privatelabel who can only create blackout events
    let detail_fields = buildFields(
      Displaylists,
      data,
      canOnlyCreatePersonalEvent
    );
    return _.assign(
      detail_fields,
      FormUtils.buildAddressFields(Displaylists, data)
    ); //add venue fields
  },

  onFormChanged(field_path, new_value) {
    let self = this;
    let data = _.get(this, "state.data", {});

    //make sure the stoptime > starttime
    if ("starttime" === field_path && _.isDate(new_value)) {
      this.setState({ data: data }, function () {
        if (
          !_.isDate(data.stoptime) ||
          data.stoptime.getTime() < new_value.getTime()
        ) {
          self.Form_onChange("stoptime", _.cloneDeep(new_value));
        }
      });
    }

    if ("stoptime" === field_path && _.isDate(new_value)) {
      this.setState({ data: data }, function () {
        if (
          !_.isDate(new_value) ||
          new_value.getTime() < data.starttime.getTime()
        ) {
          self.Form_onChange("stoptime", _.cloneDeep(data.starttime));
        }
      });
    }
  },

  render() {
    let self = this;
    let fields = this.Form_buildSchema();
    let data = this.state.data || {};
    let { onCancel, has_remote_contact, __openGrabModal } = this.props;
    //let { Displaylists } = this.props;
    let speaker_id = _.get(data, "speaker", null);
    let is_limited_speaker =
      AuthedUserSession.doIHaveAccess.limited_speaker.any([speaker_id]);

    let has_pro = _.includes(
      AuthedUserSession.getSIDsAtPackageLevel("PRO"),
      esUtils.toInt(data.speaker)
    );

    let renderFieldLayout = function (layout) {
      return ezHorizontalFields(
        self,
        _.filter(layout, function (row) {
          return _.size(row) === 1 ? _.has(fields, row[0]) : true;
        }),
        "sm",
        2
      );
    };

    return (
      <form className="form-horizontal" onSubmit={this.Form_onSubmit}>
        <h4 className="section-head">New Event</h4>
        {renderFieldLayout([
          ["speaker", "deliveryMethod"],
          ["organization"],
          ["status", "personal"],
        ])}
        <h4 className="section-head">When & Where</h4>
        {renderFieldLayout([["no_date"]])}
        {!data.no_date &&
          renderFieldLayout([
            ["starttime", "stoptime"],
            //                ["add_flights"],
          ])}
        {_.includes([NaN, 0, 1], _.parseInt(data.deliveryMethod)) && (
          <div style={{ marginTop: "1em" }}>
            {renderFieldLayout([["city"], ["st", "country"]])}
          </div>
        )}

        {!has_remote_contact && (
          <div>
            <h4 className="section-head">Primary Contact</h4>
            {!is_limited_speaker && has_pro && (
              <div className="row" style={{ marginBottom: "0.5rem" }}>
                <div className="col-sm-offset-1 col-sm-10">
                  {dd.a(
                    {
                      href: "#",
                      onClick: __openGrabModal.bind(null, speaker_id),
                    },
                    "GRAB a crm contact"
                  )}
                </div>
              </div>
            )}
            {renderFieldLayout([
              ["contact_name"],
              ["contact_phone", "contact_email"],
            ])}
          </div>
        )}

        {/* eslint-enable no-constant-condition */}
        <h4 className="section-head">Other</h4>
        {renderFieldLayout([
          !data.personal ? ["todolists"] : null,
          ["bureauID"],
          ["bureauNotes"],
        ])}
        <div className="form-group text-center" style={{ marginTop: "30px" }}>
          <button type="submit" className="btn btn-primary">
            Create Event
          </button>
          <button
            className="btn btn-default"
            onClick={onCancel}
            style={{ marginLeft: "1em" }}
          >
            Cancel
          </button>
        </div>
      </form>
    );
  },
});

module.exports = dd.createClass({
  mixins: [RadioServiceMixin],

  RadioService_setup() {
    return {
      Event_my_events_on_date: {
        key: "callService",
        on: {
          succeeded: (data) => {
            if (_.size(data) === 0) {
              this.__saveTheEvent();
            }
          },
          failed: (error) => {
            //ignore this error b/c it's not a big deal
            this.__saveTheEvent();
          },
        },
      },
    };
  },

  getInitialState() {
    return {
      event_to_save: null,
      date_to_check_first: null,
      contact_from_grab: null,
      show_grab_modal: false,
      grab_speaker_id: null,
    };
  },
  __saveTheEvent: esUtils.wrapPreventDefault(function () {
    radio("save_Event").broadcast(this.state.event_to_save);
    this.setState({
      event_to_save: null,
      date_to_check_first: null,
      Event_my_events_on_date: {},
    });
  }),
  __dontSaveTheEvent: esUtils.wrapPreventDefault(function () {
    this.setState({
      event_to_save: null,
      date_to_check_first: null,
      Event_my_events_on_date: {},
    });
  }),
  __onSubmit(data) {
    let event = {
      eid: 0,
      sids: [esUtils.toInt(data.speaker)],
      parentID: Math.max(0, esUtils.toInt(this.__parseUrlParams().parent_id)),
      remotecontactID: this.__parseUrlParams().remotecontact_id,
      organization: data.organization,
      status: data.status,
      isPersonal: !!data.personal,
      bureauID: esUtils.toInt(data.bureauID),
      bureauNotes: data.bureauNotes,
      todolistids: [],
      companyID: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]),
      deliveryMethod: esUtils.toInt(data.deliveryMethod),
    };
    if (!esUtils.isBlank(data.todolists)) {
      event.todolistids = [esUtils.toInt(data.todolists)];
    }
    if (event.sids[0] > 0) {
      AuthedUserSession.setLastSelectedSID(event.sids[0]);
    }

    if (!data.no_date) {
      event.Stagetime = [
        {
          id: 0,
          description: "presentation",
          starttime: data.starttime,
          stoptime: data.stoptime,
        },
      ];
    }

    event.Venue = [
      {
        id: 0,
        city: data.city,
        country: data.country,
        st: data.st,
      },
    ];

    if (
      !_.isEmpty(data.contact_name) ||
      !_.isEmpty(data.contact_phone) ||
      !_.isEmpty(data.contact_email)
    ) {
      event.EventContact = [
        {
          id: 0,
          cname: data.contact_name,
          email: data.contact_email,
          phone: data.contact_phone,
          groupcodes: ["PRIM"],
          flags: 1, //primary contact
          externalid: data.contact_remote_id,
        },
      ];
    }

    event.add_temp_flights = !data.no_date && data.add_flights;

    let self = this;
    this.setState(
      {
        event_to_save: event,
        date_to_check_first:
          !data.no_date && _.isDate(data.starttime) ? data.starttime : null,
      },
      function () {
        if (_.isDate(self.state.date_to_check_first)) {
          this.RadioService_callService("Event_my_events_on_date", {
            "yyyy-mm-dd": dateformat(
              self.state.date_to_check_first,
              "yyyy-mm-dd"
            ),
            speaker_ids: self.state.event_to_save.sids,
          });
        } else {
          this.__saveTheEvent();
        }
      }
    );
  },
  __openGrabModal: function (speaker_id, e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    this.setState({ show_grab_modal: true, grab_speaker_id: speaker_id });
  },
  __onCloseGrabModal: esUtils.wrapPreventDefault(function (data) {
    this.setState({ show_grab_modal: false, contact_from_grab: data });
  }),
  __openEvent(event_id) {
    return esUtils.wrapPreventDefault(function () {
      radio("Hashbang_set").broadcast("/events/" + event_id);
    });
  },
  __cancel: esUtils.wrapPreventDefault(function () {
    radio("Hashbang_set").broadcast("");
  }),
  __parseUrlParams() {
    let { url_params } = this.props;
    let r = {
      date: null,
      parent_id: 0,
      remotecontact_id: null,
    };
    if (/^\s*[0-9]+\-[0-9]+\-[0-9]+\s*$/.test(url_params[0])) {
      let [y, m, d] = url_params[0].split("-");
      r.date = new Date(
        esUtils.toInt(y),
        esUtils.toInt(m) - 1,
        esUtils.toInt(d)
      );
    } else if (url_params[0] === "child") {
      r.parent_id = esUtils.toInt(url_params[1]);
    } else if (url_params[0] === "remotecontact") {
      r.remotecontact_id = url_params[1];
    }
    return r;
  },
  render() {
    let { Displaylists } = this.props;
    let ajax = this.state.Event_my_events_on_date;
    let events = ajax.data;
    let defaultGrabservice = localStorage.getItem("default_grab_service");
    defaultGrabservice = _.isEmpty(defaultGrabservice)
      ? "EP"
      : defaultGrabservice;
    let contact_from_grab = this.state.contact_from_grab;
    return dd.div(
      { className: "NewEventForm panel panel-default", style: { margin: 10 } },
      dd.div(
        { className: "panel-body" },
        LoadingWrap(
          { is_loading: ajax.waiting, glass: true },
          NewForm({
            Displaylists,
            url_date: this.__parseUrlParams().date,
            onSubmit: this.__onSubmit,
            onCancel: this.__cancel,
            has_parent: this.__parseUrlParams().parent_id > 0,
            has_remote_contact: !_.isEmpty(
              this.__parseUrlParams().remotecontact_id
            ),
            contact_from_grab,
            __openGrabModal: this.__openGrabModal,
          })
        )
      ),
      this.state.show_grab_modal
        ? SearchAContactService({
            service: defaultGrabservice,
            event: { sids: [this.state.grab_speaker_id] },
            onClose: this.__onCloseGrabModal,
          })
        : null,
      _.size(events) > 0
        ? Modal(
            {
              title: "Are you sure?",
              onClose: this.__dontSaveTheEvent,
              buttons: [
                {
                  name: "Yes",
                  onClick: this.__saveTheEvent,
                  className: "btn btn-default",
                },
                {
                  name: "No",
                  onClick: this.__dontSaveTheEvent,
                  className: "btn btn-default",
                },
              ],
            },
            dd.p(
              null,
              _.size(events) === 1
                ? dd.span(null, "There is one event on ")
                : dd.span(null, "There are ", _.size(events), " events on "),
              dateformat(this.state.date_to_check_first, "dddd, mmmm d, yyyy"),
              ":"
            ),
            dd.div(
              { style: { margin: "1em 0 1em 1em" } },
              _.map(
                events,
                function (event) {
                  return dd.div(
                    {
                      key: event.eid,
                      style: { marginBottom: 10, lineHeight: "28px" },
                      className: "clickable",
                      onClick: this.__openEvent(event.eid),
                    },
                    dd.div(
                      { className: "pull-left", style: { marginRight: 10 } },
                      esStatusImage({
                        status: event.eventconfirmed,
                        delivery_method: event.deliverymethod,
                        has_parent: event.parentid > 0,
                        has_children: event.n_children > 0,
                        size: 30,
                      })
                    ),
                    dd.div(
                      null,
                      event.organization,
                      " ",
                      event.meetingname,
                      " ",
                      event.ispersonal ? "(personal)" : ""
                    ),
                    dd.div({ className: "clearfix" })
                  );
                },
                this
              )
            ),
            dd.div(null, "Do you still want to create your event on this date?")
          )
        : null
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/NewEventForm_simple.js